/* Keep the on-site captions imported from social feeds consistent with the brand name. */
(() => {
  const normalize = (root) => {
    if (!root || !root.querySelectorAll) return;
    const captions = [];
    if (root.matches && root.matches('.LeeepListCaption')) captions.push(root);
    if (root.closest) {
      const parent = root.closest('.LeeepListCaption');
      if (parent) captions.push(parent);
    }
    captions.push(...root.querySelectorAll('.LeeepListCaption'));
    for (const caption of new Set(captions)) {
      const walker = document.createTreeWalker(caption, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.includes('N/H')) node.nodeValue = node.nodeValue.replaceAll('N/H', 'N／H');
      }
    }
  };
  const start = () => {
    normalize(document.body);
    new MutationObserver((changes) => {
      for (const change of changes) {
        if (change.type === 'characterData') normalize(change.target.parentElement);
        else for (const node of change.addedNodes) normalize(node.nodeType === 3 ? node.parentElement : node);
      }
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
